export const initialState = {
  banners: [],
  loading: false,
  error: null,
  nextToken: null,
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case "REQUEST_LIST_BANNER":
      return {
        ...state,
        banners: [],
        loading: true,
        nextToken: null,
        error: null,
      };
    case "LIST_BANNER_SUCCESS":
      return {
        ...state,
        banners: action.payload.items,
        nextToken: action.payload.nextToken,
        loading: false,
      };
    case "LIST_BANNER_ERROR":
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};
